import React, {useEffect} from 'react';

import SimpleCardContainer from "../../ui/SimpleCardContainer";
import {useApi} from "../../../providers/ApiProvider";
import BusinessesModel from "../../../models/BusinessesModel";
import {Link, useParams} from "react-router-dom";
import {useBreadcrumbs} from "../../../providers/BreadcrumbsProvider";
import BusinessViewHeader from "./../BusinessViewHeader";
import BusinessViewMenu from "../BusinessViewMenu";
import {useNotifications} from "../../../providers/NotificationsProvider";
import {useTranslation} from "react-i18next";
import {useTranslation as useMyTranslation} from "../../../providers/TranslationProvider";
import ButtonWithLoading from "../../layout/ui/ButtonWithLoading";
import BusinessCompetitorCard from "./BusinessCompetitorCard";
import StarRating from "../../ui/StarRating";

function BusinessCompetitorsManage({}) {
    const {language} = useMyTranslation();
    const { t} = useTranslation();
    const params = useParams();
    const notificationsContext = useNotifications();
    const apiContext = useApi();
    const businessesModel = new BusinessesModel(apiContext.api);


    const breadcrumbs = useBreadcrumbs();
    const [competitors, setCompetitors] = React.useState([1, 2, 3, 4, 5]);
    const [loading, setLoading] = React.useState(false);


    const refreshCompetitors = () => {
        setLoading(true);

        businessesModel.refreshCompetitors(params.locationId).then((response) => {
            if (response !== false) {
                setCompetitors(response);
            }
        }).finally(() => {
            setLoading(false);
        });
    }


    const setMetaData = (profile) => {
        if (profile !== false) {
            breadcrumbs.update({
                title: profile.title,
                breadcrumbs: [
                    {label: t('Businesses List'), url: '/businesses'},
                    {label: profile.title, url: '/businesses/'+params.locationId},
                    {label: t('Competitors'), url: '/businesses/'+params.locationId+'/competitors'},
                    {label: t('Manage competitors')}
                ]
            });

            document.title = t('Manage competitors')+' | '+profile.title+' | LocalBoost';
        }
    }


    const onProfileRefresh = (profile, lastUpdated) => {
        setMetaData(profile);
        refreshCompetitors();
    }


    useEffect(() => {
        businessesModel.view(params.locationId).then((response) => {
            if (response !== false) {
                setMetaData(response.data);
            }
        });

        refreshCompetitors();
    }, [language]);


    return (
        <>
			<BusinessViewHeader
				locationId={params.locationId}
				onProfileRefresh={onProfileRefresh}
			/>
			<BusinessViewMenu locationId={params.locationId} active="competitors" />


            <div className="d-flex justify-content-end align-items-center mt-3">
                <ButtonWithLoading
                    className="btn-primary"
                    noOriginalIconClassName={true}
                    iconClassName="d-none"
                    label={t('Suggest competitors')}
                    loading={loading}
                    onClick={refreshCompetitors}
                />
            </div>

            <table className="table table-hover table-striped">
                <thead>
                    <tr>
                        <th scope="col">{t('Title')}</th>
                        <th scope="col">{t('Type')}</th>
                        <th scope="col">{t('Contact information')}</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    {competitors.map((competitor, index) => {
                        return (
                            <tr key={'competitor-'+index}>
                                <td className="w-100">
                                    <h6 className="mb-0">
                                        <Link target="_blank" rel="noopener noreferrer" to={competitor.googleMapsUri}>
                                            {competitor.displayName ? competitor.displayName.text : competitor.id}
                                        </Link>
                                    </h6>
                                    <div className="d-flex gap-3 align-items-center">
                                        <StarRating rating={competitor.rating} className="mb-0" />
                                        <div className="fs-2 fw-medium text-muted">({competitor.userRatingCount})</div>
                                    </div>
                                    <div className="fs-2 mt-2">{competitor.formattedAddress}</div>
                                </td>
                                <td>{competitor.primaryTypeDisplayName ? competitor.primaryTypeDisplayName.text : ''}</td>
                                <td>
                                    {competitor.websiteUri ? (
                                    <Link target="_blank" rel="noopener noreferrer" className="d-flex" to={competitor.websiteUri}>
                                        {competitor.websiteUri}
                                    </Link>
                                    ) : ''}

                                    {competitor.internationalPhoneNumber ? (
                                    <div className="">
                                        {competitor.internationalPhoneNumber}
                                    </div>
                                    ) : ''}
                                </td>
                                <td className="text-center">
                                    <Link to="#" className="btn btn-primary btn-sm">
                                        {t('Edit')}
                                    </Link>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
}

export default BusinessCompetitorsManage;
